if (!window.golfBallProductsInit) {
window.golfBallProductsInit = true;

const initGolfBallProductsCard = (card) => {
  const images = card.querySelectorAll('.golf-ball-products__img');
  const dots = card.querySelectorAll('.golf-ball-products__dot');
  const frame = card.querySelector('.golf-ball-products__image-frame');
  const label = card.querySelector('.golf-ball-products__label');
  if (images.length === 0 || dots.length === 0) return;

  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const ensureImageLoaded = (img) => {
    if (!img) return;
    if (!img.getAttribute('src') && img.dataset.src) {
      img.setAttribute('src', img.dataset.src);
    }
    if (!img.getAttribute('srcset') && img.dataset.srcset) {
      img.setAttribute('srcset', img.dataset.srcset);
    }
  };

  const setActive = (index) => {
    ensureImageLoaded(images[index]);
    images.forEach((img, i) => img.classList.toggle('is-active', i === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    if (label) {
      label.classList.toggle('is-hidden', index !== 0);
    }
  };

  const getActiveIndex = () => {
    let index = 0;
    images.forEach((img, i) => {
      if (img.classList.contains('is-active')) index = i;
    });
    return index;
  };

  const defaultIndex = getActiveIndex();
  ensureImageLoaded(images[defaultIndex]);
  setActive(defaultIndex);

  const resetToDefault = () => {
    setActive(defaultIndex);
  };

  dots.forEach((dot) => {
    dot.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const index = Number(dot.dataset.index);
      setActive(index);
    });

    if (supportsHover) {
      dot.addEventListener('mouseenter', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const index = Number(dot.dataset.index);
        setActive(index);
      });

      dot.addEventListener('focus', () => {
        const index = Number(dot.dataset.index);
        setActive(index);
      });
    }
  });

  if (frame) {
    if (supportsHover) {
      frame.addEventListener('mouseenter', () => {
        if (images.length > 1) {
          setActive(1);
        }
      });
    }
    
    frame.addEventListener('mouseleave', resetToDefault);
    frame.addEventListener('focusout', (event) => {
      if (!frame.contains(event.relatedTarget)) {
        resetToDefault();
      }
    });
  }
};

const initGolfBallProducts = (section) => {
  const cards = section.querySelectorAll('.golf-ball-products__card');
  cards.forEach((card) => initGolfBallProductsCard(card));
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.golf-ball-products').forEach((section) => {
    if (section.dataset.enhanced) return;
    section.dataset.enhanced = 'true';
    initGolfBallProducts(section);
  });
});

}
